import React from 'react';
import { type NodeProps } from '@xyflow/react';
import { Droplets, Sprout } from 'lucide-react';
import type { BlockNodeData } from '../../lib/digitalTwinGraph';

const IrrigationBlockNode: React.FC<NodeProps> = ({ data, selected }) => {
  const { block } = data as BlockNodeData;
  return (
    <article className={`dt-block-node ${selected ? 'is-selected' : ''}`}>
      <header>
        <span><Sprout size={15} /> {block.name}</span>
        <small>{block.surface_ha ?? '—'} ha</small>
      </header>
      <div className="dt-block-pattern" aria-hidden="true" />
      <footer><Droplets size={13} /> {block.irrigation_type} · {block.theoretical_flow_m3_h ?? 0} m³/h</footer>
    </article>
  );
};

export default React.memo(IrrigationBlockNode);
